export const config = (state = window.XHS.config) => state;
